import React from 'react';
import Sidebar from '../components/Sidebar';
import Messages from './Messages';

export default function SeekerMessages() {
  return <Messages SidebarComponent={Sidebar} />;
}
